import UserList from "../../components/Admin/UserList";

export default function UsersPage() {
    return (
        <div className="space-y-6">
            <div>
                <h2 className="text-3xl font-light text-white">
                    The <span className="font-bold text-blue-500">Books of Life</span>
                </h2>
                <p className="text-gray-500 mt-2">Registry of all souls. Search, filter, and intervene.</p>
            </div>

            <UserList />
        </div>
    );
}
